import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { GETGAMES, GAMEUPDATESCORE, CREATE_GAME_SESSION, CLOSE_SESSION, BMIINFOAVERAGE, IMAGE_API_URL, GET_USER_GAMES, GET_SETTINGS_DATA, MEMBERSHIP } from "../helpers/Constant";
import { getDataWithToken, postDataWithToken } from '../api/api';
import { IoIosArrowForward } from 'react-icons/io';
import { getUserInfo, checkAuth } from '../utils/common';
import { BiSolidLock } from 'react-icons/bi';
import { Oval } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Bottombar from '../common/bottombar';
import SessionHistory from '../common/SessionHistory';
import UserRetention from './Home/userRetention';
import StreakSaver from './Home/StreakSaver';

function Game() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(0);
    const [gamesData, setGameData] = useState([]);
    const [playableGames, setPlayableGames] = useState([]);
    const [freeGameIds, setFreeGameIds] = useState([]);
    const [userData, setUserData] = useState(getUserInfo());
    const [upcomingUnlockedGame, setUpcomingUnlockedGame] = useState(null);
    const [unlockCountdown, setUnlockCountdown] = useState('');
    const [loading, setLoading] = useState(true);
    const [ShowSessionModal, setShowSessionModal] = useState(false);
    const [sessionId, setSessionId] = useState('');
    const [dailyBurned, setDailyBurned] = useState(0);
    const [piggyBankLimit, setPiggyBankLimit] = useState(500);
    const [sessionHistoryClosedSignal, setSessionHistoryClosedSignal] = useState(0);
    const [streakModalSignal, setStreakModalSignal] = useState(true);

    const refreshUserData = async () => {
        const latestUserData = await checkAuth();
        if (latestUserData) {
            setUserData(latestUserData);
        }
        return latestUserData;
    };

    useEffect(() => {
        async function fetchGameData() {
            try {
                const userGamesResponse = await getDataWithToken(GET_USER_GAMES);
                if (userGamesResponse?.playableGameIds && userGamesResponse.playableGameIds.length > 0) {
                    setPlayableGames(userGamesResponse.playableGameIds);
                } else {
                    setPlayableGames([]);
                }

                if (userGamesResponse?.upcomingUnlockedGame?.gameId && userGamesResponse?.upcomingUnlockedGame?.unlocksAt) {
                    setUpcomingUnlockedGame(userGamesResponse.upcomingUnlockedGame);
                } else {
                    setUpcomingUnlockedGame(null);
                    setUnlockCountdown('');
                }

                const settingsResponse = await getDataWithToken(GET_SETTINGS_DATA);
                setFreeGameIds(Array.isArray(settingsResponse?.free_games) ? settingsResponse.free_games : []);
                if (settingsResponse?.piggy_bank_limit) {
                    setPiggyBankLimit(parseInt(settingsResponse.piggy_bank_limit, 10) || 500);
                }
                const gamesResponse = await getDataWithToken(GETGAMES);
                setGameData(gamesResponse);

                prefetchImages(gamesResponse);
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
            
        }
        fetchGameData();
        refreshUserData();
    }, []);

    useEffect(() => {
        if (!upcomingUnlockedGame?.unlocksAt || !moment(upcomingUnlockedGame.unlocksAt).isValid()) {
            setUnlockCountdown('');
            return;
        }

        const updateCountdown = () => {
            const diff = moment(upcomingUnlockedGame.unlocksAt).diff(moment());

            if (diff <= 0) {
                setUnlockCountdown('00:00:00');
                setPlayableGames((prev) => {
                    const alreadyAdded = prev.some((game) => {
                        const id = typeof game === 'string' ? game : game?.gameId;
                        return id?.toString() === upcomingUnlockedGame.gameId?.toString();
                    });
                    if (alreadyAdded) return prev;
                    return [
                        ...prev,
                        {
                            gameId: upcomingUnlockedGame.gameId,
                            gameTitle: upcomingUnlockedGame.gameTitle,
                        },
                    ];
                });
                setUpcomingUnlockedGame(null);
                return false;
            }

            const duration = moment.duration(diff);
            const hours = String(Math.floor(duration.asHours())).padStart(2, '0');
            const minutes = String(duration.minutes()).padStart(2, '0');
            const seconds = String(duration.seconds()).padStart(2, '0');
            setUnlockCountdown(`${hours}:${minutes}:${seconds}`);
            return true;
        };

        if (!updateCountdown()) return undefined;

        const timer = setInterval(() => {
            if (!updateCountdown()) {
                clearInterval(timer);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [upcomingUnlockedGame]);

    const prefetchImages = (games) => {
        if(!games) return;
        games?.forEach((game) => {
            const img = new Image();
            img.src = IMAGE_API_URL + game.image;
        });
    };
    

    const gamePlay = async (gameTitle) => {
        setLoading(true);
        try {
            const response = await postDataWithToken(CREATE_GAME_SESSION, {});
            if (response.status === 200 && response.data) {
                const utcDateTime = new Date().toISOString();
                const dailyTarget = (userData != null && userData.dailyTarget) ? userData.dailyTarget : 1000;
                const currentDailyTarget = Math.round(dailyTarget);
                
                const url = `uniwebview://openGame?sessionId=${response.data.sessionId}&date=${encodeURIComponent(utcDateTime)}&dailyBurned=${dailyBurned}&dailyTarget=${currentDailyTarget}&name=${gameTitle}&isPrimeUser=${userData && userData.userAccount.isPrimeUser}`;
                window.location.href = url;
            }
        } catch (error) {} finally {
            setLoading(false);
        }
    }

    // End of the Game
    window.onGameClosed = async function (calories, time, score, heartbeat, accuracy, sessionId, gameName, piggyStreak=1, piggyCoin=0) {
        handleGameClosed(calories, time, score, heartbeat, accuracy, sessionId, gameName, piggyStreak, piggyCoin);
    };


    const handleGameClosed = async (calories, time, score, heartbeat, accuracy, sessionId, gameName, piggyStreak, piggyCoin) => {
        try {
            const userResult = {
                "score": score,
                "burnedCal": calories,
                "accuracy" : accuracy,
                "time" : time,
                "heartbeat" : heartbeat,
                "sessionId" : sessionId,
                "gameName" : gameName,
                "piggyStreak" : piggyStreak,
                "piggyCoin" : piggyCoin
            }
            const response = await postDataWithToken(GAMEUPDATESCORE, userResult);
            if (response.status === 200) {
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }

    window.onSessionCompleted = async function (sessionId) {
        setSessionId(sessionId);

        await postDataWithToken(`${CLOSE_SESSION}${sessionId}`);

        await refreshUserData();

        const bmiInfoData = await postDataWithToken(BMIINFOAVERAGE);
        if (bmiInfoData.data && bmiInfoData.data.length > 0) {
            setDailyBurned(bmiInfoData.data[0].burned);
        }

        // Refresh playable games after retention unlock
        try {
            const userGamesResponse = await getDataWithToken(GET_USER_GAMES);
            if (userGamesResponse?.playableGameIds && userGamesResponse.playableGameIds.length > 0) {
                setPlayableGames(userGamesResponse.playableGameIds);
            }
        } catch (error) {}

        setShowSessionModal(true);
    }

    const handleCloseSessionHistoryModal = () => {
        setShowSessionModal(false);
        if (!userData?.userAccount?.isRetentionFlowCompleted && !userData?.userAccount?.isPrimeUser) {
            setSessionHistoryClosedSignal((prev) => prev + 1);
        }
    };

    const dailyTarget = (userData != null && userData.dailyTarget) ? userData.dailyTarget : 1000;
    const dailyTargetPercentage = Math.round((dailyBurned / dailyTarget) * 100).toFixed(2);
    const playableGameIdSet = new Set(
        playableGames
            .map((game) => (typeof game === 'string' ? game : game?.gameId))
            .filter(Boolean)
            .map((id) => id.toString())
    );
    const freeGameIdSet = new Set(freeGameIds.map((id) => id?.toString()).filter(Boolean));
    const freeGamesData = gamesData.filter((game) => freeGameIdSet.has(game._id?.toString()));
    const otherGamesData = gamesData.filter((game) => !freeGameIdSet.has(game._id?.toString()));
    const upcomingGameId = upcomingUnlockedGame?.gameId?.toString();

    return (
        <>
            <div className='wrapper h-100'>
                {loading ?
                    <div className="loader">
                        <Oval color="#daff00" secondaryColor="#ffffff" strokeWidth={3} strokeWidthSecondary={3} height={50} width={50} />
                    </div>
                : ""}
                <div className="tabs-container h-100">
                    <div className="tabs d-flex">
                        <button className={`tab border-0 ${activeTab === 0 ? 'active' : 'text-white bg-transparent '}`} onClick={() => setActiveTab(0)}>{t('Games')}</button>
                        <button className={`tab border-0 ${activeTab === 1 ? 'active' : 'text-white bg-transparent '}`} onClick={() => setActiveTab(1)}>{t('Premium games')}</button>
                    </div>
                    <div className="tab-content text-white">
                        {activeTab === 0 && (
                            <>
                                {freeGamesData.map((game) => (
                                    <div key={game._id} className='d-flex game_wrapper align-items-start justify-content-end flex-wrap'>
                                        <img src={(IMAGE_API_URL + game.image)} alt="Logo" />
                                        <div className='game_info'>
                                            <h5 className='mb-0'>{game.title}</h5>
                                            <div dangerouslySetInnerHTML={{ __html: game.description }}></div>
                                        </div>
                                        <div className='play_button_Wrapper'>
                                            {
                                                (userData && !userData.userAccount.isPrimeUser) || playableGameIdSet.has(game._id?.toString()) ?
                                                    <button className='w-100' type='button' onClick={() => gamePlay(game.title)}>{t('Play')}< IoIosArrowForward /></button> :
                                                    <span className='lock_icon text-center d-inline-block rounded-circle'>
                                                        <BiSolidLock color='515157' size={22} className=' my-1' />
                                                    </span>
                                            }
                                        </div>
                                    </div>
                                ))}
                            </>
                        )}
                        {activeTab === 1 && (
                        <>
                            {otherGamesData.map((game) => (
                                <div key={game._id} className='d-flex game_wrapper align-items-start justify-content-end flex-wrap'>
                                    <img src={(IMAGE_API_URL + game.image)} alt="Logo" />
                                    <div className='game_info'>
                                        <h5 className='mb-0'>{game.title}</h5>
                                        <div dangerouslySetInnerHTML={{ __html: game.description }}></div>
                                    </div>
                                    <div className='play_button_Wrapper'>
                                        {
                                            (userData && userData.userAccount.isPrimeUser) || playableGameIdSet.has(game._id?.toString()) ?
                                                <button className='w-100' type='button' onClick={() => gamePlay(game.title)}>{t('Play')}< IoIosArrowForward /></button> :
                                                upcomingGameId && game._id?.toString() === upcomingGameId && unlockCountdown ? (
                                                    <div className='unlock_countdown text-center'>
                                                        <span className='lock_icon text-center d-inline-block rounded-circle mb-1'>
                                                            <BiSolidLock color='515157' size={22} className=' my-1' />
                                                        </span>
                                                        <p className='mb-0 text-warning fw-bold unlock_countdown_timer'>{unlockCountdown}</p>
                                                    </div>
                                                ) : (
                                                    <span className='lock_icon text-center d-inline-block rounded-circle'>
                                                        <BiSolidLock color='515157' size={22} className=' my-1' />
                                                    </span>
                                                )
                                        }
                                    </div>
                                </div>
                            ))}
                            {(!userData || !userData.userAccount.isPrimeUser) && (
                                <div className='premium_button_wrapper position-fixed start-0 end-0 p-3 text-center'>
                                    <button className='cta_button bg-warning' type='button' onClick={() => navigate(`/${MEMBERSHIP}`)}>Buy Premium</button>
                                </div>
                            )}
                        </>
                        )}
                    </div>
                </div>

                {ShowSessionModal && sessionId !== '' ? <SessionHistory showSessionHistoryModal={ShowSessionModal} sessionId={sessionId} closeSessionHistoryModal={handleCloseSessionHistoryModal} dailyBurned={dailyBurned} dailyTarget={dailyTarget} dailyTargetPercentage={dailyTargetPercentage} showRetentionData={true} /> : ''}

                <StreakSaver user={userData} onUserRefresh={refreshUserData} showStreakInfoModal={false} closeStreakInfoModal={() => {}} streakModalSignals={setStreakModalSignal} />

                {!userData?.userAccount?.isRetentionFlowCompleted && !userData?.userAccount?.isPrimeUser && (
                    <UserRetention
                        userData={userData}
                        piggyBankLimit={piggyBankLimit}
                        sessionHistoryClosedSignal={sessionHistoryClosedSignal}
                        streakModalClosedSignal={streakModalSignal}
                        onUserRefresh={refreshUserData}
                    />
                )}

                <Bottombar />
            </div>
        </>
    );
}
export default Game
